// extracted by mini-css-extract-plugin
export default {"right_box":"index_right_box_vn1-U","stock_box":"index_stock_box_ej5fG"};